module.exports = __webpack_public_path__ + "fonts/AudiType-ExtendedBold_4.03.ae0aa554.woff";